import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";
import { useOrganization } from "@api/organization.api";
import { useWorkspacesList } from "@api/workspace.api";
import { Menu } from "@design-system/Menu/Menu.lib";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useOrganizationDemoWorkspace } from "@hooks/useOrganizationDemoWorkspace";
import { useScope } from "@state/scopeContext.lib";
import { FC } from "react";

const PERSONAL_VIEW_VALUE = "personal";

export const OrganizationSwitcher: FC = () => {
    const { data: organization } = useOrganization();
    const workspace = useActiveWorkspace();
    const { changeActiveOrganization, clear, organizationId } = useScope();
    const personalWorkspaces = useWorkspacesList();
    const { demoWorkspace, openDemoWorkspace } = useOrganizationDemoWorkspace();
    const showPersonalViewOption = personalWorkspaces.data?.some(
        ({ organizationIds }) => organizationIds.length === 0,
    );

    if (!organization) {
        return null;
    }

    const getSelectedValue = () => {
        if (workspace) {
            return "";
        }
        if (!organizationId) {
            return PERSONAL_VIEW_VALUE;
        }
        return organizationId === organization.id ? organization.id : "";
    };

    return (
        <>
            <Menu.RadioGroup
                value={getSelectedValue()}
                onValueChange={(value) =>
                    value === PERSONAL_VIEW_VALUE
                        ? clear()
                        : changeActiveOrganization(organization)
                }
            >
                <Menu.GroupLabel>Firm</Menu.GroupLabel>
                {showPersonalViewOption && (
                    <Menu.RadioItem value={PERSONAL_VIEW_VALUE}>
                        Personal
                    </Menu.RadioItem>
                )}
                <Menu.RadioItem value={organization.id}>
                    {organization.name}
                </Menu.RadioItem>
            </Menu.RadioGroup>
            {demoWorkspace && (
                <Menu.Item
                    onClick={() =>
                        openDemoWorkspace(
                            OrganizationMemberClientAccessSource.SWITCHER,
                        )
                    }
                >
                    Demo client
                </Menu.Item>
            )}
        </>
    );
};
